import { createContext, useContext, useState } from "react";

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("vireo_lang") || "en"; } catch { return "en"; }
  });
  const setLang = (l) => {
    try { localStorage.setItem("vireo_lang", l); } catch {}
    setLangState(l);
    document.documentElement.lang = l;
  };
  // t({en, fr}) — falls back to en if fr missing
  const t = (obj) => {
    if (typeof obj === "string") return obj;
    if (lang === "fr" && obj.fr) return obj.fr;
    return obj.en ?? "";
  };
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
